<template>
  <div class="chart-container">

    <h2 class="chart-question" v-if="opts.options.showQuestion">{{chartData.label}}</h2>

    <legend class="chart-legend-container">
      <div v-for="(sub, subIndex) in chartData.answersData[0].subQuestionAnswers" v-bind:key="sub.id" class="chart-legend">
        <div class="legendMatrix" v-bind:class="'matrix-' + (subIndex +1)" v-on:click="sortMatrix(sub.id)"></div>
          <span class="legendMatrix" v-on:click="sortMatrix(sub.id)">{{sub.label}}</span>
      </div>
    </legend>
    <ul class="chart-list">
      <li v-for="answer in chartData.answersData" v-bind:key="answer.answerId">
        <div class="chart-horizontal">
          <div class="chart-picture-container" v-if="opts.options.showIllustrations &&answer.picture">
            <img :src="`${answer.picture}`" :alt="`${answer.pictureAlt || ''}`" class="chart-picture" />
          </div>
          <div class="chart-middle">
            <div class="chart-label">
              <span v-html="answer.label"></span>
            </div>
            <div class="chart-bar-value">
              <div class="chart-bar-container chart-bar-matrix">
                <div
                  class="chart-bar matrix-bar"
                  v-bind:class="'matrix-' + (subIndex +1)"
                  v-bind:style="'width:' + answer.calculateValues[subIndex] + '%;'"
                  v-for="(sub, subIndex) in answer.subQuestionAnswers" v-bind:key="sub.id">

                    <div class="matrix-value" v-if="opts.options.showVotesByAnswer">
                      <span class="matrix-percentage">{{answer.calculateValues[subIndex]}}%</span>
                      <span class="matrix-votes">{{sub.result}} {{translations.votes}}</span>
                    </div>

                </div>
              </div>
            </div>
            <div class="chart-average">
                <p>
                  <span class="average-label">{{translations.average}}: </span>
                  <span class="average-value">{{answer.averageLabel}}</span>
                </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { calculateTotalPercent } from '../../helpers/percentagesTo100'
import { calculatePercentage } from '../../helpers/calculatePercentage'

export default {
  name: 'Matrix',
  props: ['chartData', 'translations', 'opts'],
  methods: {
    resizeAndSetDivHeight: function () {
      const divs = document.getElementsByClassName('chart-picture-container')
      if (!divs[0]) return
      var w = divs[0].offsetWidth

      for (var i = 0; i < divs.length; i++) {
        if (w !== 0) {
          divs[i].style.height = w + 'px'
        }
      }
    },
    // comparator by Krazar
    comparator: (id) => (a, b) => {
      const maxA = a.subQuestionAnswers.find(response => response.id === id)
      const maxB = b.subQuestionAnswers.find(response => response.id === id)

      if (!maxA) {
        return 1
      } else if (!maxB) {
        return -1
      }
      const resultA = maxA.result
      const resultB = maxB.result

      return resultB - resultA
    },
    sortMatrix: function (id) {
      this.chartData.answersData.sort(this.comparator(id))
    }
  },
  created () {
    for (let i = 0; i < this.chartData.answersData.length; i++) {
      let falsedPercents = []
      for (let j = 0; j < this.chartData.answersData[i].subQuestionAnswers.length; j++) {
        if (this.chartData.answersData[i].subQuestionAnswers[j].result !== 0) {
          falsedPercents.push(calculatePercentage(this.chartData.answersData[i].subQuestionAnswers[j].result, this.chartData.answersData[i].subQuestionAnswers.total, 1))
        } else {
          falsedPercents.push(0)
        }
      }

      this.chartData.answersData[i].calculateValues = calculateTotalPercent(falsedPercents, 100)
      falsedPercents = []
    }
  },
  mounted () {
    var that = this
    that.resizeAndSetDivHeight()
    window.onresize = function (event) {
      that.resizeAndSetDivHeight()
    }
  }
}
</script>

<style scoped src="../../assets/css/chart-matrix.css">
</style>



// WEBPACK FOOTER //
// src/components/charts/Matrix.vue